var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col md:grid grid-cols-7 md:gap-x-4 mb-10 md:mb-[60px]"},[_c('p',{staticClass:"col-span-2 -md:text-sm mb-3 md:mb-1"},[_vm._v(_vm._s(_vm.item.title))]),_vm._v(" "),_c('div',{staticClass:"col-span-5 flex flex-wrap gap-[6px]"},[_c('AtomText',{attrs:{"content":_vm.item.text,"class-name":"whitespace-pre-wrap"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }